import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-details-vehicle',
  templateUrl: './summary-details-vehicle.component.html',
  styleUrls: ['./summary-details-vehicle.component.scss'],
})
export class SummaryDetailsVehicleComponent {
  @Input() titleSummary = '';
  @Input() isOpen = false;

  toggleDetails(event: Event) {
    this.isOpen = !this.isOpen;
    event.stopPropagation();
  }
}
